import React from 'react'
import './index.scss'
import device from 'current-device'
import { renderIf } from '../../lib/util'

export const redirect = () => {
  const userAgent = navigator.userAgent

  if (userAgent.match(/iPhone/)) {
    window.location.href = 'https://itunes.apple.com/us/app/basemap-own-the-outdoors/id1305237481?ls=1&mt=8'
    return false
  } else if (userAgent.match(/Android/)) {
    window.location.href = 'https://play.google.com/store/apps/details?id=com.mobile.basemap'
    return false
  } else if (userAgent.match(/iPad|Macintosh/)) {
    window.location.href = 'https://itunes.apple.com/us/app/basemap-own-the-outdoors/id1305237481?ls=1&mt=8'
    return false
  } else {
    window.location.href = 'https://play.google.com/store/apps/details?id=com.mobile.basemap'
    return false
  }
}

export default () => (
  <div className="redirect-page">
    {renderIf(
      device.type == 'desktop',
      <div>
        <img src="./asset/Basemap_Primary_Corp_Logo.png" className="redirect-page--image" />
        <p className="redirect-page--paragraph">
          To provide you with the best user experience, we've blocked the app on a smaller window size. Please resize
					your browser window to unblock.
        </p>
      </div>,
      <div>
        <img src="./asset/Basemap_Primary_Corp_Logo.png" className="redirect-page--image" />
        <p className="redirect-page--paragraph">
          For the best mobile experience, download the app on your phone.
          <br />
          <br />
          Enjoy our web app on computer or tablet.
        </p>
        <button onClick={redirect} className="redirect-page--button">
          Go to App Store
        </button>
      </div>
    )}
  </div>
)
